import {useContext, useEffect, useMemo} from 'react';
import {RevealEditorMobile} from '~/common/FabricInvitation/EventCreateDesign/components/Reveal/Mobile/RevealEditorMobile';
import {useEnvelopeContext} from '~/common/FabricInvitation/EventCreateDesign/contexts/EnvelopeContext';
import {EventCreateContext} from '~/common/FabricInvitation/EventCreateDesign/EventCreateContext';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {OverlayAnimation} from '~/common/OverlayAnimation/OverlayAnimation';
import {RevealEditor} from './RevealEditor';

export const RevealContainer = ({children}) => {
  const isLargishAndUp = useIsLargishAndUp();
  const {revealVideo} = useContext(EventCreateContext);
  const {setEnvelopeProps} = useEnvelopeContext();

  const revealAnimation = useMemo(
    () => <OverlayAnimation autoPlay revealVideo={revealVideo} fixed />,
    [revealVideo]
  );

  useEffect(() => {
    setEnvelopeProps({
      showStamp: true,
      canvas: false,
      showStickers: true,
      type: 'image',
      message: "Guest's name will go here",
    });
  }, [setEnvelopeProps]);

  return (
    <>
      {children}
      {isLargishAndUp ? <RevealEditor /> : <RevealEditorMobile />}
      {revealAnimation}
    </>
  );
};
